type OrganisationIntegrationSettingsRoute = {
  name: string;
  path: string;
};

export const IntegrationSettingsBaseRoute =
  '/organisation/settings/integrations';

const organisationSettingsRoutes: Record<
  string,
  OrganisationIntegrationSettingsRoute
> = {
  createJobs: {
    name: 'CreateJobsPage',
    path: '/create-jobs',
  },
  integrationSettings: {
    name: 'OrganisationIntegrationSettingsPage',
    path: '/',
  },
  sdbIntegration: {
    name: 'SDBIntegrationPage',
    path: '/sdb',
  },
  selectJobs: {
    name: 'SelectJobsPage',
    path: '/select-jobs',
  },
} as const;

export default organisationSettingsRoutes;
